// brand object repository

import http from '../services/http'
import auth from '../services/auth'

const BASE_ROUTE = '/brand'

export default {
  fetchTeamBrands: function (teamId) {
    // fetch the list of brands for the provided teamId
    return http.get(`${BASE_ROUTE}/`, auth.getAuthHeader(), {team: teamId})
  }
}
